import React, { useState } from "react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  // Common link styles
  const linkClasses =
    "block px-3 py-2 text-white transition-colors duration-200 hover:text-yellow-400 md:hover:text-yellow-500";

  return (
    <nav className="fixed top-0 w-full z-50 bg-black shadow-md">
      <div className="max-w-screen-xl mx-auto px-4 py-3 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center">
          <a href="#" className="flex items-center text-white space-x-2">
            <img src="lum-logo.png" alt="Lumiere" className="h-10 w-auto" />
            <span className="hidden sm:inline-block font-semibold text-xl">LUMIERE</span>
          </a>
        </div>

        {/* Hamburger Button (Shown on Mobile) */}
        <button
          onClick={handleToggle}
          className="md:hidden text-white hover:text-yellow-400 focus:outline-none transition-colors"
          aria-label="Toggle Menu"
        >
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {isOpen ? (
              // X icon when menu is open
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              // Hamburger icon when menu is closed
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>

        {/* Full Menu (Desktop & Mobile) */}
        <div
          className={`absolute md:static top-[60px] left-0 right-0 bg-black md:bg-transparent overflow-hidden transition-all duration-300 ease-in-out 
            ${isOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"} 
            md:max-h-full md:opacity-100
          `}
        >
          <ul className="flex flex-col md:flex-row md:items-center md:space-x-6">
            <li>
              <a href="#" className={`${linkClasses} md:text-yellow-500`}>
                Home
              </a>
            </li>
            <li>
              <a href="#" className={`${linkClasses} md:text-yellow-500`}>
                About
              </a>
            </li>
            <li>
              <a href="#" className={`${linkClasses} md:text-yellow-500`}>
                Services
              </a>
            </li>
            <li>
              <a href="#" className={`${linkClasses} md:text-yellow-500`}>
                Pricing
              </a>
            </li>
            <li>
              <a href="#" className={`${linkClasses} md:text-yellow-500`}>
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
